import { CarTag } from '../types/brandSchema';

export const PopularSizes: CarTag[] = [
  {
    title: '232x175x225',
    href: '/catalog/accumulators/all_sizes/232x175x225/',
  },
  {
    title: '315x175x175',
    href: '/catalog/accumulators/all_sizes/315x175x175/',
  },
  {
    title: '242x175x175',
    href: '/catalog/accumulators/all_sizes/242x175x175/',
  },
  {
    title: '353x175x190',
    href: '/catalog/accumulators/all_sizes/353x175x190/',
  },
  {
    title: '260x175x225',
    href: '/catalog/accumulators/all_sizes/260x175x225/',
  },
  {
    title: '151x88x147',
    href: '/catalog/accumulators/all_sizes/151x88x147/',
  },
  {
    title: '306x175x225',
    href: '/catalog/accumulators/all_sizes/306x175x225/',
  },
  {
    title: '242x175x190',
    href: '/catalog/accumulators/all_sizes/242x175x190/',
  },
  {
    title: '276x175x190',
    href: '/catalog/accumulators/all_sizes/276x175x190/',
  },
  {
    title: '136x61x131',
    href: '/catalog/accumulators/all_sizes/136x61x131/',
  },
  {
    title: '276x175x175',
    href: '/catalog/accumulators/all_sizes/276x175x175/',
  },
  {
    title: '518x274x237',
    href: '/catalog/accumulators/all_sizes/518x274x237/',
  },
  {
    title: '315x175x190',
    href: '/catalog/accumulators/all_sizes/315x175x190/',
  },
  {
    title: '393x175x190',
    href: '/catalog/accumulators/all_sizes/393x175x190/',
  },
  {
    title: '353x175x175',
    href: '/catalog/accumulators/all_sizes/353x175x175/',
  },
  {
    title: '207x175x175',
    href: '/catalog/accumulators/all_sizes/207x175x175/',
  },
  {
    title: '207x175x190',
    href: '/catalog/accumulators/all_sizes/207x175x190/',
  },
  {
    title: '514x175x210',
    href: '/catalog/accumulators/all_sizes/514x175x210/',
  },
  {
    title: '513x223x225',
    href: '/catalog/accumulators/all_sizes/513x223x225/',
  },
  {
    title: '238x129x225',
    href: '/catalog/accumulators/all_sizes/238x129x225/',
  },
  {
    title: '513x223x223',
    href: '/catalog/accumulators/all_sizes/513x223x223/',
  },
  {
    title: '518x274x240',
    href: '/catalog/accumulators/all_sizes/518x274x240/',
  },
  {
    title: '513x218x210',
    href: '/catalog/accumulators/all_sizes/513x218x210/',
  },
  {
    title: '187x127x225',
    href: '/catalog/accumulators/all_sizes/187x127x225/',
  },
  {
    title: '152x88x147',
    href: '/catalog/accumulators/all_sizes/152x88x147/',
  },
  {
    title: 'Все размеры АКБ',
    href: '/catalog/accumulators/all_sizes/',
  },
];

export const PopularСontainers: CarTag[] = [
  {
    title: '100 Ah',
    href: '/catalog/accumulators/capacity/100/',
  },
  {
    title: '105 Ah',
    href: '/catalog/accumulators/capacity/105/',
  },
  {
    title: '110 Ah',
    href: '/catalog/accumulators/capacity/110/',
  },
  {
    title: '12 Ah',
    href: '/catalog/accumulators/capacity/12/',
  },
  {
    title: '13 Ah',
    href: '/catalog/accumulators/capacity/13/',
  },
  {
    title: '140 Ah',
    href: '/catalog/accumulators/capacity/140/',
  },
  {
    title: '190 Ah',
    href: '/catalog/accumulators/capacity/190/',
  },
  {
    title: '225 Ah',
    href: '/catalog/accumulators/capacity/225/',
  },
  {
    title: '230 Ah',
    href: '/catalog/accumulators/capacity/230/',
  },
  {
    title: '240 Ah',
    href: '/catalog/accumulators/capacity/240/',
  },
  {
    title: '40 Ah',
    href: '/catalog/accumulators/capacity/40/',
  },
  {
    title: '5.5 Ah',
    href: '/catalog/accumulators/capacity/5.5/',
  },
  {
    title: '50 Ah',
    href: '/catalog/accumulators/capacity/50/',
  },
  {
    title: '54 Ah',
    href: '/catalog/accumulators/capacity/54/',
  },
  {
    title: '55 Ah',
    href: '/catalog/accumulators/capacity/55/',
  },
  {
    title: '60 Ah',
    href: '/catalog/accumulators/capacity/60/',
  },
  {
    title: '61 Ah',
    href: '/catalog/accumulators/capacity/61/',
  },
  {
    title: '62 Ah',
    href: '/catalog/accumulators/capacity/62/',
  },
  {
    title: '64 Ah',
    href: '/catalog/accumulators/capacity/64/',
  },
  {
    title: '65 Ah',
    href: '/catalog/accumulators/capacity/65/',
  },
  {
    title: '66 Ah',
    href: '/catalog/accumulators/capacity/66/',
  },
  {
    title: '68 Ah',
    href: '/catalog/accumulators/capacity/68/',
  },
  {
    title: '70 Ah',
    href: '/catalog/accumulators/capacity/70/',
  },
  {
    title: '72 Ah',
    href: '/catalog/accumulators/capacity/72/',
  },
  {
    title: '73 Ah',
    href: '/catalog/accumulators/capacity/73/',
  },
  {
    title: '74 Ah',
    href: '/catalog/accumulators/capacity/74/',
  },
  {
    title: '75 Ah',
    href: '/catalog/accumulators/capacity/75/',
  },
  {
    title: '80 Ah',
    href: '/catalog/accumulators/capacity/80/',
  },
  {
    title: '85 Ah',
    href: '/catalog/accumulators/capacity/85/',
  },
  {
    title: '90 Ah',
    href: '/catalog/accumulators/capacity/90/',
  },
  {
    title: '92 Ah',
    href: '/catalog/accumulators/capacity/92/',
  },
  {
    title: '95 Ah',
    href: '/catalog/accumulators/capacity/95/',
  },
  {
    title: 'Все ёмкости АКБ',
    href: '/catalog/accumulators/capacity/',
  },
];
